import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import type { Team } from "@/types/team";
import { Search, Users } from "lucide-react";
import { useState } from "react";
import TeamCard from "./TeamCard";

interface TeamsListProps {
  teams: Team[];
  onEdit: (team: Team) => void;
  onManageAgents: (team: Team) => void;
}

export default function TeamsList({
  teams,
  onEdit,
  onManageAgents,
}: TeamsListProps) {
  const [search, setSearch] = useState("");

  const filteredTeams = teams.filter((team) =>
    team.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <Card className="p-4 mb-6">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
          <Input
            placeholder="Buscar equipes..."
            className="pl-10"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredTeams.length === 0 ? (
          <div className="col-span-full flex flex-col items-center justify-center p-8">
            <Users className="h-12 w-12 text-muted-foreground mb-4" />
            <p className="text-muted-foreground text-center">
              Nenhuma equipe encontrada
            </p>
          </div>
        ) : (
          filteredTeams.map((team) => (
            <TeamCard
              key={team._id}
              team={team}
              onEdit={() => onEdit(team)}
              onManageAgents={() => onManageAgents(team)}
            />
          ))
        )}
      </div>
    </>
  );
}
